// Default booking experience & rig data.
// Used as a fallback when no admin-managed records exist in the database,
// and to prefill the admin editor. Editing live values happens in AdminExperiences.

export const EXPERIENCE_DATA = {
  adult_sim_racing: {
    name: 'ADULT SIM RACING EXPERIENCE',
    price: 60,
    duration_minutes: 50,
    tag: 'AGES 16+',
    allowed_rigs: ['sabelt_amg', 'sabelt_porsche', 'treq_fanatec'],
    description:
      'Get behind the wheel of a pro-spec direct drive sim rig for 50 minutes of pure drive time, complete with triple monitors, load cell pedals and a professional safety briefing. Whether you are chasing faster lap times, learning racecraft or just want the thrill, our instructors are on hand to help you unlock your full potential. Ages 16+.',
    specs: [
      'Pro-grade direct drive wheel',
      'Load cell pedals',
      'Triple monitor setup',
      'Instructor briefing included',
    ],
    build_specs: [],
  },
  child_sim_racing: {
    name: 'CHILD SIM RACING EXPERIENCE',
    price: 45,
    duration_minutes: 50,
    tag: 'AGES 8–15',
    allowed_rigs: ['child_sim'],
    description:
      'A child-friendly sim session on an adapted rig with controls sized for younger drivers. Includes 50 minutes of drive time, full staff supervision throughout and an instructor briefing to get them up to speed. Perfect for ages 8–15 looking to experience real sim racing in a safe, supervised environment.',
    specs: [
      'Child-friendly sim rig',
      'Adapted controls for younger drivers',
      'Supervised by staff',
      'Instructor briefing included',
    ],
    build_specs: [],
  },
  young_racer: {
    name: 'YOUNG RACER EXPERIENCE',
    price: 20,
    duration_minutes: 30,
    tag: 'AGES 5–7',
    allowed_rigs: ['child_sim'],
    description:
      'A dedicated, safety-first child sim rig designed for first-timers aged 5–7. Includes 30 minutes of drive time on fun introductory racing games, always supervised by our staff so younger drivers can enjoy their first taste of sim racing with confidence.',
    specs: [
      'Dedicated child sim rig (safety-first)',
      'Fun introductory racing games',
      'Always supervised by staff',
      'Designed for first-timers',
    ],
    build_specs: [],
  },
};

export const ADULT_RIG_DATA = {
  sabelt_amg: {
    name: 'SABELT AMG',
    tag: 'ADULT RIG',
    description: "Our sim racing experts are dedicated to helping you unlock your full potential behind the wheel. Whether you're chasing faster lap times, mastering racecraft, or refining your setup, we'll guide you every step of the way.",
  },
  sabelt_porsche: {
    name: 'SABELT PORSCHE',
    tag: 'ADULT RIG',
    description: "Our sim racing experts are dedicated to helping you unlock your full potential behind the wheel. Whether you're chasing faster lap times, mastering racecraft, or refining your setup, we'll guide you every step of the way.",
  },
  treq_fanatec: {
    name: 'TREQ ACE 1',
    tag: 'ADULT RIG',
    description: "Our sim racing experts are dedicated to helping you unlock your full potential behind the wheel. Whether you're chasing faster lap times, mastering racecraft, or refining your setup, we'll guide you every step of the way.",
  },
  child_sim: {
    name: 'CHILD SIM RIG',
    tag: 'JUNIOR RIG',
    description: "A dedicated child-friendly sim rig with adapted controls, safety-first setup, and full staff supervision throughout the session.",
  },
};

// Legacy rig data kept for backward compatibility with older bookings
export const RIG_DATA = {
  sabelt_amg: { name: 'SABELT AMG' },
  sabelt_porsche: { name: 'SABELT PORSCHE' },
  treq_fanatec: { name: 'TREQ ACE 1' },
  child_sim: { name: 'CHILD SIM RIG' },
};

// All rig keys that are NOT the child-sim rig. Used as the default allowed_rigs
// for any experience whose default data doesn't specify one (safety fallback).
export const ALL_ADULT_RIG_KEYS = Object.keys(ADULT_RIG_DATA).filter((k) => k !== 'child_sim');